import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import axios from 'axios'

// rsuite
import Table from 'rsuite/Table'
import Tag from 'rsuite/Tag'
import Toggle from 'rsuite/Toggle'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// includes
import Edit2 from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import {isEmpty} from 'lodash'
import {toast} from 'react-toastify'
import {SortType} from 'rsuite-table/lib/@types/common'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import {StateParamsModel} from 'src/app/modules/common/Model'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import * as subsidiaryPage from '../index'
import * as subsidiaryCategory from '../../subsidiaryCategory'
import AddSubsidiaryPage from './AddSubsidiaryPage'
import ReorderSubsidiarySections from './ReorderSubsidiarySections'
import {buildSortLabel} from './buildSortLabel'
import {CONTENT_TYPE_LABELS} from './contentTypeLabels'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

const SubsidiaryPageComponent = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const {
    data,
    loading,
    singleEnableSuccess,
    singleDisableSuccess,
    enableSuccess,
    disableSuccess,
    toggleLoading,
    success,
    deleteSuccess,
    subsidiaryPageList,
    sortSubsidiaryPageData,
  } = useSelector((state: any) => state.subsidiaryPage)
  const {subsidiaryCategoryList} = useSelector((state: any) => state.subsidiaryCategory)
  const [layoutOptions, setLayoutOptions] = useState<any[]>([])
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
    orderBy: 'order',
  })
  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)
  const [openReorder, setOpenReorder] = useState(false)

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const enableSubsidiaryPageData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(subsidiaryPage.actions.enableSubsidiaryPage(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const disableSubsidiaryPageData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(subsidiaryPage.actions.disableSubsidiaryPage(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    function handleAction() {
      alert(`id:${rowData[dataKey]}`)
    }
    return (
      <Cell {...props} className='link-group'>
        <CheckPermissions type='Edit'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Edit</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              data-cy='edit-button'
              icon={<Edit2 />}
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Delete</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let branchId = [rowData.id]
                setCheckedValues(branchId)
              }}
              data-cy='delete-button'
              icon={<TrashIcon />}
            />
          </Whisper>
        </CheckPermissions>
        <Whisper placement='top' trigger='hover' speaker={<Tooltip>Status</Tooltip>}>
          <Toggle
            size='sm'
            disabled={toggleLoading}
            checked={rowData.status}
            onClick={() => handleToggleAction(rowData)}
            data-cy='toggle-button'
          />
        </Whisper>
      </Cell>
    )
  }

  const handleToggleAction = (data: {[key: string]: string}) => {
    data?.status
      ? dispatch(subsidiaryPage.actions.singleDisableSubsidiaryPage({id: data.id}))
      : dispatch(subsidiaryPage.actions.singleEnableSubsidiaryPage({id: data.id}))
  }

  const Cell = Table.Cell

  const handleClose = () => setOpen(false)

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Category',
      dataKey: 'categoryName',
      flexGrow: 1,
      cell: <Cell dataKey='categoryName' />,
      sortable: false,
    },
    {
      label: 'Content Type',
      dataKey: 'contentTypeLabel',
      flexGrow: 1,
      cell: <Cell dataKey='contentTypeLabel' />,
      sortable: false,
    },
    {
      label: 'Status',
      dataKey: 'status',
      width: 85,
      cell: (
        <Cell>
          {(rowData) =>
            rowData?.status ? (
              <Tag color='green' size='sm'>
                Active
              </Tag>
            ) : (
              <Tag color='red' size='sm'>
                Inactive
              </Tag>
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  useEffect(() => {
    dispatch(subsidiaryPage.actions.getSubsidiaryPage(params))
  }, [params])

  useEffect(() => {
    dispatch(subsidiaryCategory.actions.getAllSubsidiaryCategory())
    axios
      .get(`${API_URL}/home-page-component`, {params: {page: 1, limit: 200}})
      .then((res) => setLayoutOptions(res?.data?.data?.components ?? []))
      .catch(() => setLayoutOptions([]))
  }, [])

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Subsidiary Manager deleted successfully')
    }
    if (enableSuccess) {
      toast.success('Subsidiary Manager enabled successfully')
    }
    if (disableSuccess) {
      toast.success('Subsidiary Manager disabled successfully')
    }
    handleChecked([])
    dispatch(subsidiaryPage?.actions.getSubsidiaryPage(params))
  }, [deleteSuccess, success, enableSuccess, disableSuccess])

  useEffect(() => {
    if (singleEnableSuccess) {
      toast.success('Subsidiary Manager enabled successfully')
    }
    if (singleDisableSuccess) {
      toast.success('Subsidiary Manager disabled successfully')
    }
    handleChecked([])
  }, [singleDisableSuccess, singleEnableSuccess])

  const subsidiaryPageData = data?.subsidiaryPage
    ? data?.subsidiaryPage?.map((item: any, i: number) => {
        const cat = (subsidiaryCategoryList?.subsidiaryCategory ?? []).find(
          (c: any) => c.id === item.subsidiaryCategoryId
        )
        const comp = layoutOptions.find((lm: any) => lm.id === item.layoutManagerId)
        const categoryName = cat?.name ?? ''
        const contentTypeLabel = comp ? CONTENT_TYPE_LABELS[comp.title] ?? comp.title : ''
        return {
          ...item,
          sn: (params?.page - 1) * params?.limit + (i + 1),
          categoryName,
          contentTypeLabel,
        }
      })
    : []

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const handleDelete = () => {
    let subsidiaryPageId = checkedValues?.map((value) => ({id: value}))
    dispatch(subsidiaryPage?.actions?.deleteSubsidiaryPage(subsidiaryPageId))
    handleAlertClose()
  }
  const handleRefresh = () => {
    dispatch(subsidiaryPage.actions.getSubsidiaryPage(params))
  }

  useEffect(() => {
    if (!isEmpty(sortSubsidiaryPageData) && success) {
      toast.success('Subsidiary sections sorted successfully')
      dispatch(subsidiaryPage.actions.sortSubsidiaryPageReset())
      const nextParams = {...params, limit: 10}
      setParams(nextParams)
      dispatch(subsidiaryPage.actions.getSubsidiaryPage(nextParams))
      setOpenReorder(false)
    }
  }, [sortSubsidiaryPageData, success])

  return (
    <>
      <div className='shadow p-3 bg-white rounded'>
        <DesignComponent
          moduleName='Subsidiary Manager'
          params={params}
          setParams={setParams}
          handleRefresh={handleRefresh}
          handleAddModal={handleAddModal}
          handleAlertOpen={handleAlertOpen}
          exportShow={false}
          importShow={false}
          enableMultiple={enableSubsidiaryPageData}
          disableMultiple={disableSubsidiaryPageData}
          data={subsidiaryPageData}
          loading={loading}
        />

        <div className='d-flex justify-content-end mb-3'>
          <button
            type='button'
            className='btn btn-primary btn-sm'
            onClick={() => setOpenReorder(true)}
            data-cy='reorder-sections-button'
          >
            Reorder Sections
          </button>
        </div>

        <div className='datatable'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={columns}
            data={subsidiaryPageData}
            checkedValues={checkedValues}
            showLoading={loading}
            handleSort={handleSort}
          />
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
          />
          {open && (
            <AddSubsidiaryPage
              open={open}
              params={params}
              handleClose={handleClose}
              actionType={actionType}
              editSelectedData={editSelectedData}
            />
          )}
          {openReorder && (
            <ReorderSubsidiarySections
              open={openReorder}
              handleClose={() => setOpenReorder(false)}
              layoutOptions={layoutOptions}
            />
          )}
        </div>

        {/* Delete Modal */}
        {alertOpen &&
          (!isEmpty(checkedValues) ? (
            <DeleteModal
              handleClick={() => handleDelete()}
              isOpen={alertOpen}
              handleClose={() => handleAlertClose()}
            />
          ) : (
            toast.error('No data selected') && setAlertOpen(false)
          ))}
      </div>
    </>
  )
}

export default SubsidiaryPageComponent
